export const COUPON_CONSTANTS = {
  // Coupon List
  FETCH_COUPONS_REQUEST: "FETCH_COUPONS_REQUEST",
  FETCH_COUPONS_SUCCESS: "FETCH_COUPONS_SUCCESS",
  FETCH_COUPONS_FAILURE: "FETCH_COUPONS_FAILURE",
  // Coupon Users
  FETCH_COUPON_USERS_REQUEST: "FETCH_COUPON_USERS_REQUEST",
  FETCH_COUPON_USERS_SUCCESS: "FETCH_COUPON_USERS_SUCCESS",
  FETCH_COUPON_USERS_FAILURE: "FETCH_COUPON_USERS_FAILURE",
};
